export const shouldFetch = (data?: { paramsFetch?: unknown }) => data?.paramsFetch != null;
